import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { Icon } from "@iconify/react";
import "../../Assets/CSS/Active.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const data = [
  {
    id: 1,
    name: "Project Name A",
    owner: "Atul Thakur",
    status: "Completed",
    tasks: 44,
    progress: 40,
    color: "#00AFEF",
    progresColor: "#00EF50",
  },
  {
    id: 2,
    name: "Project Name B",
    owner: "Atul Thakur",
    status: "InProgress",
    tasks: 24,
    progress: 63,
    color: "#8300EF",
    progresColor: "#00EF50",
  },
  {
    id: 3,
    name: "Project Name C",
    owner: "Atul Thakur",
    status: "InProgress",
    tasks: 36,
    progress: 43,
    color: "#EF00A3",
    progresColor: "#00EF50",
  },
  {
    id: 4,
    name: "Project Name D",
    owner: "Atul Thakur",
    status: "InProgress",
    tasks: 62,
    progress: 23,
    color: "#EF7000",
    progresColor: "#00EF50",
  },
  {
    id: 5,
    name: "Project Name E",
    owner: "Atul Thakur",
    status: "InProgress",
    tasks: 99,
    progress: 40,
    color: "#8FD700",
    progresColor: "#00EF50",
  },
  {
    id: 6,
    name: "Project Name F",
    owner: "Atul Thakur",
    status: "InProgress",
    tasks: 24,
    progress: 90,
    color: "#00EF58",
    progresColor: "#00EF50",
  },
];

const MyProject = () => {
  const [activeTab, setActiveTab] = useState("active");
  const navigate = useNavigate();

  const [projectList, setProjectList] = useState([]);

  const token = localStorage.getItem("token");

  // Fetch employee list
  useEffect(() => {
    const featchuser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/projects`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response?.data, `project data`);
        setProjectList(response?.data?.content);
      } catch (error) {
        console.error("Error creating team:", error);
      }
    };
    featchuser();
  }, []);
  const projectNameStyle = {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "22px",
    color: "#303030",
  };

  const thStyle = {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "14px",
    color: "#909090",
  };

  const tdStyle = {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "16px",
  };

  const renderTable = (filteredData) => (
    <div className="mt-4">
      <table className="">
        <thead className="headerTable">
          <tr>
            <th
              style={{
                ...thStyle,
                borderTopLeftRadius: "10px",
                borderBottomLeftRadius: "10px",
              }}
            >
              Project Name
            </th>
            <th style={thStyle}>Owner</th>
            <th style={thStyle}>Status</th>
            <th style={thStyle}>Tasks</th>
            <th
              style={{
                ...thStyle,
                borderTopRightRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            >
              Progress
            </th>
          </tr>
        </thead>
        <tbody className="tableBody">
          {filteredData.map((item) => (
            <tr
              key={item.id}
              className="table-row2"
              onClick={() => navigate(`/projectDesc/${item.projectId}`)}
              //   onClick={() => navigate(`/projectDesc/${item.id}`)}
              style={{ cursor: "pointer" }}
            >
              <td style={{ ...tdStyle, color: item.color }}>
                {item.projectName}
              </td>
              <td style={tdStyle}>{item.ownerName}</td>
              <td>
                <span
                  className="status-pill"
                  style={{ fontFamily: "Inter, sans-serif", fontSize: "14px" }}
                >
                  {item.status}
                </span>
              </td>
              <td style={{ ...tdStyle, color: item.color }}>
                {item.totalTasks || 0}
              </td>
              <td className="progress-cell">
                <div className="progress-wrapper">
                  {/*
      Calculate progress percentage:
      (completedTasks / totalTasks) * 100
    */}
                  {(() => {
                    const total = item.totalTasks || 0;
                    const completed = item.completedTasks || 0;
                    const progress =
                      total > 0 ? Math.round((completed / total) * 100) : 0;

                    // 🎨 Optional: set color based on progress
                    let progressColor = "#0d6efd"; // default blue
                    if (progress < 40) progressColor = "#dc3545"; // red for low
                    else if (progress < 80)
                      progressColor = "#ffc107"; // yellow for medium
                    else progressColor = "#28a745"; // green for high

                    return (
                      <>
                        <span
                          className="progress-text"
                          style={{ ...tdStyle, color: "#909090" }}
                        >
                          {progress}%
                        </span>
                        <div className="progress-track">
                          <div
                            className="progress-fill"
                            style={{
                              width: `${progress}%`,
                              backgroundColor: progressColor,
                            }}
                          ></div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <Layout>
      <div className="backgound-main-content">
        <Icon
          icon="material-symbols:arrow-back-rounded"
          width="24"
          height="24"
          className="back-icon"
          onClick={() => navigate(-1)}
        />
        <span className="back-text">Back</span>
        <div className="d-flex justify-content-between p-3">
          <p style={projectNameStyle}>My Projects</p>
          <button
            className="add-emp-button"
            onClick={() => navigate("/create-new-project")}
          >
            <Icon icon="material-symbols:add-rounded" width="18" height="18" />{" "}
            New Project
          </button>
        </div>

        {/* Tabs */}
        <ul
          className="nav nav-tabs d-flex mb-4"
          style={{ borderBottom: "1px solid #DBDBDB" }}
        >
          <li className="nav-item">
            <button
              className="nav-link fw-semibold px-3"
              onClick={() => setActiveTab("active")}
              style={{
                backgroundColor: "transparent",
                border: "none",
                borderBottom:
                  activeTab === "active"
                    ? "3px solid #00AFEF"
                    : "3px solid transparent",
                color: activeTab === "active" ? "#00AFEF" : "#909090",
                fontSize: "16px",
                transition: "all 0.3s ease",
              }}
            >
              Active
            </button>
          </li>
          <li className="nav-item ms-3">
            <button
              className="nav-link fw-semibold px-3"
              onClick={() => setActiveTab("completed")}
              style={{
                backgroundColor: "transparent",
                border: "none",
                borderBottom:
                  activeTab === "completed"
                    ? "3px solid #00AFEF"
                    : "3px solid transparent",
                color: activeTab === "completed" ? "#00AFEF" : "#909090",
                fontSize: "16px",
                transition: "all 0.3s ease",
              }}
            >
              Completed
            </button>
          </li>
        </ul>

        {/* Tab Content */}
        {activeTab === "active" &&
          renderTable(
            projectList.filter(
              (item) =>
                item.status === "InProgress" || item.status === "CREATED"
            )
          )}
        {activeTab === "completed" &&
          renderTable(
            projectList.filter((item) => item.status === "COMPLETED")
          )}
      </div>
    </Layout>
  );
};

export default MyProject;
